import Cookies from 'js-cookie'

const TokenKey = 'pcToken'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

// 检测是否自动登录 7天
export function checkAutoLogin() {
  const token = localStorage.getItem('token');
  const expireTime = localStorage.getItem('expire_time');
  const currentTime = new Date().getTime();

  // 如果有 token 且没有过期
  if (token && expireTime && currentTime < expireTime) {
    // Token 未过期，自动登录
    // 你可以通过向后端发送请求来验证 token 是否有效
    // 如果有效，则保持登录状态
    // console.log("用户已自动登录");
    return true; // 返回登录状态
  } else {
    // Token 过期或不存在
    // console.log("自动登录失败，token 无效或已过期");
    return false; // 返回登录失败状态
  }
}